module.exports = __webpack_public_path__ + "static/media/42x40-7.9ecf4feb.png";